import React from 'react';
import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Checkbox from '@/components/General/inputs/Checkbox';
import FieldLabel from './FieldLabel';

/**
 * Renders a `checkboxGroup` schema field (multi-select). Reuses a group of
 * `Checkbox` components, one per `config.options`. The payload value is an
 * array of selected option `value`s.
 */
const CheckboxGroupField = ({ field, value, onChange, disabled }) => {
    const config = field.config || {};
    const options = (config.options || []).map((opt) => {
        if(typeof opt === 'object' && opt !== null) return opt;
        return { label: String(opt), value: String(opt) };
    });
    const selected = Array.isArray(value) ? value : [];

    const toggle = (optionValue) => {
        if(selected.includes(optionValue)){
            onChange(selected.filter((v) => v !== optionValue));
        } else {
            onChange([...selected, optionValue]);
        }
    };

    return (
        <View style={styles.container}>
            <FieldLabel
                label={field.label}
                required={field.required}
                description={field.description}
                testID={`form-field-${field.fieldId}-label`}
            />
            <View style={styles.options}>
                {options.map((opt) => (
                    <Checkbox
                        key={opt.value}
                        testID={`form-field-${field.fieldId}-${opt.value}`}
                        checked={selected.includes(opt.value)}
                        onChange={() => toggle(opt.value)}
                        disabled={disabled}
                        label={opt.label}
                    />
                ))}
            </View>
        </View>
    );
};

const styles = StyleSheet.create(({ spacing }) => ({
    container: {
        marginVertical: spacing.sm,
    },
    options: {
        gap: spacing.sm,
    },
}));

export default CheckboxGroupField;
